import { DashboardRouter } from "../dashboard.router";

export class CreateUserRouter {
    
    static getRoute(): string {
        return `${DashboardRouter.getRoute()}/create-user`
    }

}